module.exports = __webpack_public_path__ + "media/images/icon-calendar-a83a65d7b1f29cf2535ba35b0a2e6ce7.png";